// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import {
    chain,
    ValidateEmail,
    ValidateFax,
    ValidatePhone,
    ValidatePostalCode,
} from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import constants from "@store/constants";
import getPostalCodeConstants from "@store/Framework/Common/Utilities/getPostalCodeConstants";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, ValidatePostalCode, props => {
    const { addressFieldDisplayCollection, validationRules } = props.parameter;
    const { postalCode, country } = props.parameter.address;
    const { invalidMessage, label, regExp } = getPostalCodeConstants(country);

    if (addressFieldDisplayCollection.postalCode?.isVisible) {
        if (validationRules.postalCode?.isRequired && !postalCode.trim()) {
            props.addressErrors.postalCode = siteMessage("Field_Required", label());
        } else if (!validationRules.postalCode?.isDisabled && Boolean(postalCode.trim()) && !regExp.test(postalCode)) {
            props.addressErrors.postalCode = invalidMessage();
        }
    }
});

addToChainAfter(chain, ValidatePhone, props => {
    const { addressFieldDisplayCollection, validationRules } = props.parameter;
    const { phone } = props.parameter.address;
    const { invalidMessage, regExp } = constants.formField.phone;

    if (
        addressFieldDisplayCollection.phone?.isVisible &&
        !validationRules.phone?.isDisabled &&
        Boolean(phone.trim()) &&
        !regExp.test(phone)
    ) {
        props.addressErrors.phone = invalidMessage();
    }
});

addToChainAfter(chain, ValidateEmail, props => {
    const { addressFieldDisplayCollection, validationRules } = props.parameter;
    const { email } = props.parameter.address;
    const { invalidMessage, regExp } = constants.formField.email;

    if (
        addressFieldDisplayCollection.email?.isVisible &&
        !validationRules.email?.isDisabled &&
        Boolean(email.trim()) &&
        !regExp.test(email)
    ) {
        props.addressErrors.email = invalidMessage();
    }
});

addToChainAfter(chain, ValidateFax, props => {
    const { addressFieldDisplayCollection, validationRules } = props.parameter;
    const { fax } = props.parameter.address;
    const { invalidMessage, regExp } = constants.formField.phone;

    if (
        addressFieldDisplayCollection.fax?.isVisible &&
        !validationRules.fax?.isDisabled &&
        Boolean(fax.trim()) &&
        !regExp.test(fax)
    ) {
        props.addressErrors.fax = invalidMessage();
    }
});
